import { confirmPopup } from "primereact/confirmpopup"; // To use confirmPopup method

export { confirmPopup };
